<div class="row">
  <div class="col s12 m6">
    <h4 class="card-title">Dashboard Custom</h4>
  </div>
  <!-- <div class="col s12 m6 right-align">
    <a (click)="dataExportCsv()" *ngIf="!isLoading" class="waves-effect waves-light grey lighten-1 btn mb-1" style="min-width: 158px;">
      <i class="material-icons right">format_list_bulleted</i> Export CSV
    </a>
    <div *ngIf="isLoading">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
<div class="row">
  <div class="col s12 m12">
    <div class="col s12 m4">
    <label style="font-weight: 100; font-size: medium;">From Date: &nbsp;&nbsp;</label>
    <input (dateTimeChange)="dateChange()" [(ngModel)]="selectedMoment" [owlDateTime]="dt1" style="width: 190px;">
    <span class="trigger" [owlDateTimeTrigger]="dt1">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time #dt1></owl-date-time>
    </div>

    <div class="col s12 m4">
    <label style="font-weight: 100; font-size: medium;">To Date: &nbsp;&nbsp;</label>
    <input [(ngModel)]="selectedMomentX" [owlDateTime]="dt2" style="width: 190px;" disabled="disabled">
    <span class="trigger" [owlDateTimeTrigger]="dt2">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time #dt2></owl-date-time>
    </div>

  </div>
  <!-- <div class="col s12 m6" style="display: flex; justify-content: flex-end; align-items: center;">
    <i (click)="pageData.autoRefresh = !pageData.autoRefresh" class="material-icons tatt-i-btn mr-1" [ngClass]="{'icon-light-blue': pageData.autoRefresh}">refresh</i>
    <a class='hide dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2' href='#' data-target='ddl_dashboard_areas' style="min-width:158px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="!area">-- ALL --</span>
      <span *ngIf="area">{{area.areaName}}</span>
    </a>
    <ul id='ddl_dashboard_areas' class='dropdown-content'>
      <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
      </li>
    </ul>
    <div style="max-width: 400px;">
      <select class="ddl-001" (change)="areaSelectDdl($event.target.value)">
        <option *ngFor="let rec of pageData.areas; let iRec = index;" [ngValue]="iRec">{{rec.areaName}}</option>
      </select>
    </div>
  </div> -->
</div>
<div>
  <!-- <div class="row">
    <div class="col s12 m8 left-align" *ngIf="area">
      <img src="./assets/img/floorplans/{{client + '-' + area.areaName}}.png?v=20220613" alt="" class="responsive-img" style="opacity:1;">
      
    </div>
    <div *ngIf="pageData.areas4Occupancy.length>0" class="col s12 m4 xl4">
      <div id="flight-card" class="card ocp-card">
          <div class="card-header ocp-card-title">
            <div class="card-title">
                <h5 class="task-card-title mb-3 mt-0 ocp-card-title-h">Occupancy</h5>
                <p class="flight-card-date ocp-card-title-value">Current Occupancy</p>
            </div>
          </div>
          <div *ngIf="isLoadingOccupancy" class="center-align" style="font-style:italic; font-size:0.9rem;">Loading..</div>
          <div class="card-content-bgz ocp-card-content">
            <div class="card-content" style="opacity: 1 !important;">
                <div class="row flight-state-wrapper hide">
                  <div class="col s5 m5 l5 center-align">
                      <div class="flight-state">
                        <h4 class="margin white-text">LDN</h4>
                        <p class="ultra-small">London</p>
                      </div>
                  </div>
                  <div class="col s2 m2 l2 center-align"><i class="material-icons flight-icon">local_airport</i></div>
                  <div class="col s5 m5 l5 center-align">
                      <div class="flight-state">
                        <h4 class="margin white-text">SFO</h4>
                        <p class="ultra-small">San Francisco</p>
                      </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col s8 m8 x8 center-align">
                      <div class="flight-info">
                        <p class="small" *ngFor="let rec of pageData.areas4Occupancy"><span class="text-lighten-4" style="font-size:20px;">{{rec.areaName}}</span> </p>
                      </div>
                  </div>
                  <div class="col s4 m4 x4 center-align flight-state-two">
                      <div class="flight-info">
                        <p class="small" *ngFor="let rec of pageData.areas4Occupancy"><span class="grey-text text-lighten-4" ></span> <span style="font-size:20px;">{{rec.occupancyTitle}}</span></p>
                      </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </div>
    <div *ngIf="pageData.areas4Occupancy.length>0" class="col s12 m6 hide">
      <div class="card-panel gradient-45deg-light-blue-cyan gradient-shadow white-text">
        <span class="card-title">Occupancy</span>
        <div class="row">
          <div *ngFor="let rec of pageData.areas4Occupancy" class="col s12">
            {{rec.areaName}} : {{rec.occupancyTitle}} 
          </div>
        </div>
      </div>
    </div>
  </div> -->
<div class="row">
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.inValue}}</h5>
          <p class="no-margin">Entry Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-shadow gradient-45deg-light-blue-cyan white-text">people</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.inValue>0">{{dataHis.inValue}}</span>
            <span *ngIf="dataHis.inValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}" *ngIf="1==1">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.outValue}}</h5>
          <p class="no-margin">Exit Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.outValue>0">{{dataHis.outValue}}</span>
            <span *ngIf="dataHis.outValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}" *ngIf="1!=1">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.maxOccupancy}}</h5>
          <p class="no-margin">Max Occupancy</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.maxOccupancy>0">{{dataHis.maxOccupancy}}</span>
            <span *ngIf="dataHis.maxOccupancy<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{peakHourTitle}}</h5>
          <p class="no-margin">Peak Hour</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-orange-orange gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dataHis.peakHourTitle}}</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isShowDTD" class="col s12 m3 14">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{dwelltimeMinute/60 | number:'1.1-1'}}  Min</h5>
          <p class="no-margin">Dwell Time</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-white-white gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dwelltimeMinuteLastWeek/60 | number:'1.1-1'}}  Min</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m4 l4 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0"></h4>
        <p class="medium-small"></p>
        <div class="pnl-chart-pie-01">
          <div class="chart-pie-01"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineEntry" #pdfchtLineEntry>
        <!-- <div class="row"> -->
          <div class="col s6">
            <h4 class="card-title mb-0">Hourly Entry</h4>
          </div>
          <!-- <div class="col s6"><a (click)="downloadAsPDF('chtLineEntry')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div> -->
        <!-- </div> -->
        <!-- <div class="pnl-chart-line-01">
          <div class="chart-line-01 chartLineIn"></div>
        </div> -->
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineEntry" #chtLineEntry></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineExit" #pdfchtLineExit>
        <!-- <div class="row"> -->
          <div class="col s6">
            <h4 class="card-title mb-0">Hourly Exit</h4>
          </div>
          <!-- <div class="col s6"><a (click)="downloadAsPDF('chtLineExit')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div> -->
        <!-- <div class="pnl-chart-line-01">
          <div class="chart-line-01 chartLineOut"></div>
        </div> -->
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineExit" #chtLineExit></canvas>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineOccupancy" #pdfchtLineOccupancy>
          <div class="col s6">
            <h4 class="card-title mb-0">Hourly Occupancy</h4>
          </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineOccupancy" #chtLineOccupancy></canvas>
        </div>
      </div>
    </div>
  </div> -->
  <div *ngIf="isShowDTD" class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Dwell Time</h4>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas #chtLineHourlyDwellTime></canvas>
        </div>
      </div>
    </div>
  </div>
</div>